import { withInstall } from '../../utils/install';
import Switch from './index.vue';

export const IvueSwitch = withInstall(Switch);
export default IvueSwitch;

export * from './index.vue';
